import { toPattern } from 'vanilla-masker';
import { ISolicitationViewModel } from 'viewModels';
import { v4 as uuid } from 'uuid';
import { MASK_PROCESS_NUMBER, UF_NAMES_BY_CODE } from '../../constants';
import { AudienceType, CorrespondenceType, HistoryType, ServiceStatus, labelAudienceType } from '../../types/enums';
import { Attachment } from '../Attachment';
import { Content } from './styles';

interface SolicitationContentDataProps {
  isDemand?: boolean;
  solicitation: ISolicitationViewModel;
  isVisible: boolean;
}
export function SolicitationContentData({
  isDemand,
  solicitation,
  isVisible,
}: SolicitationContentDataProps) {
  return (
    <Content className={isVisible ? '' : 'displayNone'}>
      <div className="container">
        <div className="containersolicitationData">
          <div className="requested-by">
            <p className="title">Pedido por</p>
            <div className="icon-buton">
              <p>{solicitation.createdBy?.name ?? '-'}</p>
            </div>
          </div>
          <div>
            <p className="title">Nº do processo</p>
            <p>
              {solicitation.processNumber
                ? toPattern(solicitation.processNumber, MASK_PROCESS_NUMBER)
                : '-'}
            </p>
          </div>
          {solicitation?.specialty?.name && (
            <div>
              <p className="title">Especialidade</p>
              <p>{solicitation?.specialty?.name}</p>
            </div>
          )}
          {(solicitation.status !== ServiceStatus.PENDING || !isDemand) &&
            solicitation.districtName && (
              <div>
                <p className="title">Comarca</p>
                <p>
                  {solicitation.districtName ?? ''} -
                  {solicitation.districtUfCode && UF_NAMES_BY_CODE[solicitation.districtUfCode]}
                </p>
              </div>
            )}
          {solicitation.isIntegratedProtocol &&
            solicitation.integratedProtocolValue &&
            solicitation.status !== ServiceStatus.PENDING && (
              <div>
                <p className="title">Protocolo Integrado</p>
                <p>R${solicitation.integratedProtocolValue}</p>
              </div>
            )}
          {solicitation.isVirtualAudience &&
            solicitation.audienceLink &&
            (solicitation.status !== ServiceStatus.PENDING || !isDemand) && (
              <div>
                <p className="title">Link da Audiência</p>
                <p>{solicitation.audienceLink}</p>
              </div>
            )}
          <p className="title">Partes</p>
          {solicitation.partsNames &&
            solicitation.partsNames.map((part) => {
              return (
                <div key={part.id}>
                  <p>{part.name}</p>
                </div>
              );
            })}
          {solicitation?.folderNumber && (
            <div>
              <p className="title">Número da Pasta Interno</p>
              <p>{solicitation.folderNumber}</p>
            </div>
          )}
          {(solicitation.status === ServiceStatus.CONCLUED ||
            solicitation.status === ServiceStatus.IN_APPROVAL_APPROVER ||
            solicitation.status === ServiceStatus.IN_APPROVAL_REQUESTER ||
            solicitation.status === ServiceStatus.UNPAID) &&
            solicitation.finalizationDetails && (
              <div className="date-info">
                <p className="title">Observação de finalização</p>
                <p>{solicitation.finalizationDetails}</p>
              </div>
            )}
        </div>
        <div className="containersolicitationData">
          <div>
            <p className="title">Criada em</p>
            <p>
              {new Date(solicitation.createdAt).toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
              })}
            </p>
          </div>
          <div>
            <p className="title">Prazo de Cumprimento</p>
            <p>
              {new Date(solicitation.dateLimit).toLocaleDateString('pt-BR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
              })}
            </p>
          </div>
          {solicitation.address && (
            <div>
              <p className="title">Local</p>
              <p>
                {`
                    ${solicitation?.address?.street ? `${solicitation.address.street},` : ''} 
                    ${solicitation?.address?.number ? `${solicitation.address?.number},` : 'S/Nº,'}
                    ${solicitation?.address?.city ? `${solicitation.address.city} -` : ' -'}
                    ${solicitation?.address?.uf ? solicitation.address.uf : ''}
                `}
              </p>
            </div>
          )}
          {solicitation.audienceType !== undefined && (
            <div>
              <p className="title">Tipo da Audiência</p>
              <p>{labelAudienceType[solicitation.audienceType as unknown as AudienceType]}</p>
            </div>
          )}
          {solicitation.client && (
            <div>
              <p className="title">Cliente</p>
              <p>{solicitation?.client?.name}</p>
            </div>
          )}
          {solicitation.court && (solicitation.status !== ServiceStatus.PENDING || !isDemand) && (
            <div>
              <p className="title">Vara</p>
              <p>{solicitation.court?.name}</p>
            </div>
          )}
          {solicitation.correspondent && solicitation.status !== ServiceStatus.PENDING && (
            <div>
              <p className="title">Correspondente</p>
              <p>
                {solicitation.correspondent.firstName} {solicitation.correspondent.lastName ?? ''}
              </p>
            </div>
          )}
          {(solicitation.isLawyer || solicitation.isRepresentative) &&
            (solicitation.status !== ServiceStatus.PENDING || !isDemand) && (
              <div>
                <p className="title">
                  {solicitation.audienceType !== undefined ||
                  solicitation.correspondence?.type === CorrespondenceType.AUDIENCE
                    ? 'Representação'
                    : 'Detalhes'}
                </p>
                {solicitation.isLawyer && solicitation.isRepresentative ? (
                  <p>Advogado e Preposto</p>
                ) : solicitation.isLawyer ? (
                  <p>Advogado</p>
                ) : (
                  <p>Preposto</p>
                )}
              </div>
            )}
          {solicitation.status === ServiceStatus.CONCLUED && (
            <div className="date-info">
              <div>
                <p className="title"> Encerrada em</p>
                <p>
                  {solicitation.concluedAt
                    ? new Date(solicitation.concluedAt).toLocaleString('pt-BR', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                      })
                    : ''}
                </p>
              </div>
            </div>
          )}
          {solicitation.status === ServiceStatus.CANCELED && (
            <div className="date-info">
              <p className="title"> Cancelado em</p>
              {solicitation.disabledAt && (
                <p>
                  {new Date(solicitation.disabledAt).toLocaleString('pt-BR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                  })}
                </p>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="containerMoreInformation">
        {solicitation?.note && (
          <div className="containerNote">
            <h1>Observação</h1>
            <p>{solicitation.note}</p>
          </div>
        )}
        {solicitation?.attachments && solicitation?.attachments?.length > 0 && (
          <div className="containerAttachments">
            <h1>Anexos</h1>
            <div className="contentAttachments">
              {solicitation.attachments?.map((attachment) => (
                <Attachment
                  key={attachment.id + uuid()}
                  data={{
                    id: attachment.id,
                    type: attachment.contentType ?? '',
                    name: attachment.name ?? 'Sem nome',
                  }}
                  options={{
                    disableDelete: true,
                  }}
                />
              ))}
            </div>
          </div>
        )}
        {(solicitation.status === ServiceStatus.CONCLUED ||
          solicitation.status === ServiceStatus.IN_APPROVAL_APPROVER ||
          solicitation.status === ServiceStatus.IN_APPROVAL_REQUESTER ||
          solicitation.status === ServiceStatus.UNPAID) &&
          solicitation.finalizationAttachments !== undefined &&
          solicitation.finalizationAttachments.length > 0 && (
            <div className="containerAttachments">
              <h1>Anexos de finalização</h1>
              <div className="contentAttachments">
                {solicitation.finalizationAttachments?.map((attachment) => (
                  <Attachment
                    key={attachment.id}
                    data={{
                      id: attachment.id,
                      type: attachment.contentType ?? '',
                      name: attachment.name
                        ? `${attachment.name}${attachment.extension || ''}`
                        : 'Sem nome',
                      uri: attachment.url ?? '',
                    }}
                    options={{
                      disableDelete: true,
                    }}
                  />
                ))}
              </div>
            </div>
          )}
        {solicitation?.history &&
          solicitation.history?.filter((h) => h.type === HistoryType.ATTACHMENT).length > 0 && (
            <div className="containerAttachments">
              <h1>Novos anexos</h1>
              <div className="contentAttachments">
                {solicitation.history
                  ?.filter((h) => h.type === HistoryType.ATTACHMENT)
                  .map(({ attachments }) =>
                    attachments?.map((attachment) => (
                      <Attachment
                        key={attachment.id ?? attachment.url}
                        data={{
                          id: attachment.id,
                          type: attachment.contentType ?? '',
                          name: attachment.name ?? 'Sem nome',
                          uri: attachment.url ?? '',
                        }}
                        options={{
                          disableDelete: true,
                        }}
                      />
                    )),
                  )}
              </div>
            </div>
          )}
      </div>
    </Content>
  );
}
